import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_SYSTEM_TASK } from "./graphql";
import SystemTaskItemsTable from "./SystemTaskItemsTable";
import { formatDate } from "./utils";

const SystemTaskDetailPage = () => {
  const { id } = useParams();
  const { loading, error, data, refetch } = useQuery(FETCH_SYSTEM_TASK, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const task = data?.systemTask;
  if (!task) {
    return (
      <Page title="System Task" backTo="/tools/system-tasks">
        <div className="p-6">Task not found.</div>
      </Page>
    );
  }

  return (
    <Page title={task.title || `Task #${task.id}`} backTo="/tools/system-tasks">
      <div className="p-6 space-y-4">
        <div className="card space-y-2">
          <div>
            <label className="opacity-70">Task Type: </label>
            {task.taskType || "-"}
          </div>
          <div>
            <label className="opacity-70">Source: </label>
            {task.source || "-"}
          </div>
          <div>
            <label className="opacity-70">Completed: </label>
            {formatDate(task.completedAt)}
          </div>
        </div>

        <div className="card space-y-2">
          <h5>Items ({task.items?.length || 0})</h5>
          <div className="-mx-2">
            <SystemTaskItemsTable
              items={task.items || []}
              onResolved={refetch}
            />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default SystemTaskDetailPage;
